var _linearGradient, _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 345,
    height: 230,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 172.5,
    x2: 172.5,
    y1: 230,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134d91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#1d58a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#3776d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4c8ffb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h345v230H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FF",
    d: "M264.566 153.5H80.433c-2.812 0-5.1-2.318-5.1-5.167v-36.665c0-2.85 2.288-5.168 5.1-5.168h184.133c2.812 0 5.1 2.318 5.1 5.168v36.665c0 2.849-2.288 5.167-5.1 5.167zm-184.133-46c-2.261 0-4.1 1.87-4.1 4.168v36.665c0 2.298 1.839 4.167 4.1 4.167h184.133c2.261 0 4.1-1.869 4.1-4.167v-36.665c0-2.298-1.839-4.168-4.1-4.168H80.433z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#0FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.471 85.849l7.711-6.642-7.711-6.645M106.471 77.36H92.429v3.73h14.042"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#0FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.237 90.762h14.042v-3.729H88.237M88.237 82.272l-7.711 6.645 7.711 6.645"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FF",
    d: "M236.753 80.917l7.756 9 7.758-9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank);
export default __webpack_public_path__ + "static/media/blank.bf0a32402cf8fdb6921aa52c25a12b3b.svg";
export { ForwardRef as ReactComponent };